export { GtmV2 } from './GTM.v2';
export { GtmScript } from './GTMScript';
